import { selectDefaultFolder } from "owa-mail-folder-forest-actions";

export default function mailModuleRouteHandler(): void {
    selectDefaultFolder("Route");
}
